import { createFileRoute, redirect } from '@tanstack/react-router';

import { VsmeSectionPage } from '@/features/vsme/components/VsmeSectionPage';
import { getVsmeSection, isVsmeSection } from '@/features/vsme/config';

export const Route = createFileRoute('/_authenticated/vsme/$section')({
  validateSearch: (search: Record<string, unknown>) => ({
    disclosure: typeof search.disclosure === 'string' ? search.disclosure : undefined,
  }),
  beforeLoad: ({ params }) => {
    if (params.section === 'gap-analysis') {
      // TanStack Router expects redirect to be thrown as control flow.
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({ to: '/vsme/policies-documents' });
    }

    if (!isVsmeSection(params.section)) {
      // TanStack Router expects redirect to be thrown as control flow.
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({ to: '/vsme/overview' });
    }

    return {
      getTitle: () => getVsmeSection(params.section).title,
    };
  },
  component: VsmeSectionRoute,
});

function VsmeSectionRoute() {
  const { section } = Route.useParams();

  if (!isVsmeSection(section)) {
    return null;
  }

  return <VsmeSectionPage sectionId={section} />;
}
